import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import { consumeNavSeed, saveNavCreds } from './utils/navCreds';

// 导航页账密种子：必须在 React 挂载前消费——SPA 路由重定向（Navigate/路由守卫）会在子组件
// effect 里改写 URL 丢掉 hash，App 级 effect 会输掉这场竞态（buyer path="*" 兜底已实测复现）
const navSeed = consumeNavSeed();
if (navSeed) saveNavCreds(navSeed.u, navSeed.p);

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
